var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"progress",style:({height:_vm.barHeight+'px'})},[_c('div',{staticClass:"progress-bar",class:_vm.getColorBar(),style:({width: _vm.barPorcentaje+'%'}),attrs:{"role":"progressbar","aria-label":"Example 20px high","aria-valuenow":_vm.barPorcentaje,"aria-valuemin":"0","aria-valuemax":"100"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }